module.exports = __webpack_public_path__ + "img/monitoring-desktop.c717e34b.svg";